export const CONFIG = {
  "PROJECTNAME": "royal",
  "COMPANYNAME": "Royal",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10102001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#9C742E",
    "primary100": "rgba(216,185,124,0.2)",
    "light": "#9C742E",
    "secondary": "#9C742E",
    "dark": "#9C742E",
    "siteColor3": "#fff",
    "menuSecondary": "#9C742E"
  }
};